import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import SearchField from "../SearchField/SearchField";
import USQSFormGroup from "./USQSFormGroup";
import Incoterms from "../Misc/Incoterms";
import useUSQS from "../../hooks/useUSQS";
import useUSQSUndo from "../../hooks/useUSQSUndo";
import { handleInputSelect, addEdits, ignoreEnter } from "./utils/inputhandlers";
import useGlobalParams from "../../hooks/useGlobalParams";

const QSUSADelivery = ({ showinfo, setShowinfo, clearfield }) => {
  // Load context values
  const { USQS, setUSQS, setUSQSData, whdata } = useUSQS();
  const { USQSEdits, editIDUSQS, setEditIDUSQS, undoListUSQS } = useUSQSUndo();
  const { globalparams } = useGlobalParams();

  // Local function to allow shorthand input property for onItemSelect
  const localHandleInputSelect = (item, origin, destination) => {
    handleInputSelect(
      item,
      USQSEdits,
      editIDUSQS,
      setEditIDUSQS,
      setUSQS,
      setUSQSData,
      addEdits,
      undoListUSQS,
      origin,
      destination,
      globalparams
    );
  };

  return (
    <>
      <fieldset style={{ overflow: "visible" }}>
        <legend>Delivery:</legend>
        {USQS.qstype === 2 ? (
          <USQSFormGroup
            readOnly={USQS.qstype === 2}
            labelname={"P Incoterm"}
            inputname={"pincoterm"}
            inputtype={"text"}
            cplaceholder={"P Incoterm..."}
            required={false}
          />
        ) : (
          <>
            <div className='form-group' style={{ overflow: "visible" }}>
              <label
                className='pincoterm-container'
                onMouseEnter={(e) => {
                  setShowinfo("pincoterm");
                }}
                onMouseLeave={(e) => {
                  setShowinfo("");
                }}
              >
                P Incoterm: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
                {showinfo === "pincoterm" && (
                  <div
                    className='pincoterminfo'
                    onMouseEnter={(e) => {
                      setShowinfo("pincoterm");
                    }}
                    onMouseLeave={(e) => {
                      setShowinfo("");
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                      <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                      <p> Info</p>
                    </div>
                    <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                      Enter the Purchase Incoterm.
                    </p>
                    <Incoterms />
                  </div>
                )}
              </label>

              <SearchField
                required={true}
                searchURL='/api/qs/getpincoterms'
                value={USQS?.pincoterm || ""}
                valueName='pincoterm'
                valueID='pincotermID'
                customplaceholder='P Incoterm'
                onItemSelect={(item) => localHandleInputSelect(item, "pincoterm", "pincoterm")}
                clearfield={clearfield}
              />
            </div>
          </>
        )}
        <div className='form-group' style={{ overflow: "visible" }}>
          <label
            className='pincoterm-container'
            onMouseEnter={(e) => {
              setShowinfo("sincoterm");
            }}
            onMouseLeave={(e) => {
              setShowinfo("");
            }}
          >
            D Incoterm: <FontAwesomeIcon icon={faCircleInfo} style={{ cursor: "pointer" }} />
            {showinfo === "sincoterm" && (
              <div className='pincoterminfo'>
                <div style={{ display: "flex", flexDirection: "row", marginBottom: "2rem" }}>
                  <FontAwesomeIcon icon={faCircleInfo} style={{ color: "var(--purple)", marginRight: "0.5rem" }} />
                  <p> Info</p>
                </div>
                <p style={{ width: "100%", paddingBottom: "1rem", borderBottom: "1px dashed gray" }}>
                  Enter the Delivery Incoterm.
                </p>
                <Incoterms />
              </div>
            )}
          </label>
          <SearchField
            required={true}
            searchURL='/api/qs/getsincoterms'
            value={USQS?.sincoterm || ""}
            valueName='sincoterm'
            valueID='sincotermID'
            customplaceholder='D Incoterm'
            onItemSelect={(item) => localHandleInputSelect(item, "sincoterm", "sincoterm")}
            clearfield={clearfield}
          />
        </div>
        <USQSFormGroup type={"date"} labelname={"From"} inputname={"shipfrom"} inputtype={"text"} />
        <USQSFormGroup type={"date"} labelname={"To"} inputname={"shipuntil"} inputtype={"text"} />
        {USQS.qstype !== 2 && (
          <div className='form-group'>
            <label>POL:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getlports'
              value={USQS?.POL || ""}
              valueName='POL'
              valueID='POLID'
              customplaceholder='POL'
              onItemSelect={(item) => localHandleInputSelect(item, "POL", "POL")}
              clearfield={clearfield}
            />
          </div>
        )}
        {USQS.qstype !== 2 && (
          <div className='form-group'>
            <label>POD:</label>
            <SearchField
              required={true}
              searchURL='/api/qs/getdports'
              value={USQS?.POD || ""}
              valueName='POD'
              valueID='PODID'
              customplaceholder='POD'
              onItemSelect={(item) => localHandleInputSelect(item, "POD", "POD")}
              clearfield={clearfield}
            />
          </div>
        )}
      </fieldset>
      {USQS.qstype == 2 && (
        <fieldset>
          <legend>Storage:</legend>

          <div className='form-group'>
            <label>Warehouse:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata?.["warehouse"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Fixed Cost:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata ? "$" + whdata?.["whfixedcost"].toFixed(2) : ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Variable Cost:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata ? "$" + whdata?.["whvarcost"].toFixed(2) : ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Grace Period (days):</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata?.["whgraceperiod"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>Accrual Period (days):</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata?.["whaccrualperiod"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
          <div className='form-group'>
            <label>WH Entry Date:</label>
            <input
              readOnly
              disabled
              type={"date"}
              style={{ border: "none", marginTop: "2rem" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata?.["whentrydate"] || ""}
              tabIndex={-1}
            />
          </div>
          <USQSFormGroup type={"date"} labelname={"WH Exit Date"} inputname={"whexit"} inputtype={"text"} />
          <div className='form-group'>
            <label>Eff. Days in Storage:</label>
            <input
              readOnly
              disabled
              type={"text"}
              style={{ border: "none" }}
              autoComplete='off'
              onKeyDown={ignoreEnter}
              // onFocus={(e) => e.target.select()}
              value={whdata?.["daysinstorage"] || ""}
              // name={inputname}
              tabIndex={-1}
            />
          </div>
        </fieldset>
      )}
    </>
  );
};

export default QSUSADelivery;
